import { useContext, useState } from 'react';
import { commonClassName } from 'components/organism/PriceSimulator/SimulationList/SimulationList';
import Breadcrumb from 'components/atoms/Breadcrumb';
import { pricingSimulatorDataContext } from 'contexts/PricingSimulatorContext';
import TabSwitchComponent from 'components/atoms/TabSwitch/TabSwitch';
import { tabsType } from 'types/pricingSimulator';
import { useNavigate } from 'react-router-dom';

const PricingSimulator = () => {
    const { breadcrumbItems, activeTab, setActiveTab, tabs } = useContext(pricingSimulatorDataContext);
    const navigate = useNavigate();
    return (
        <section>
            <Breadcrumb style={{ marginBottom: 10 }} items={breadcrumbItems} />
            <div className={`${commonClassName} bg-white h-full relative `} id="pricing-simulator-page">
                <div className="flex gap-2 items-center">
                    <h2 className={`font-sm m-0 w-[142px] font-medium text-blackAlt `}>{activeTab?.headerLabel}</h2>
                    {(tabs?.length || 0) > 1 && (
                        <div className="">
                            <TabSwitchComponent
                                activeTabKey={activeTab?.key}
                                onTabChange={function (tab: tabsType): void {
                                    setActiveTab(tab);
                                    navigate(tab?.url ?? '');
                                }}
                                tabs={tabs}
                            />
                        </div>
                    )}
                </div>
                {activeTab?.component}
            </div>
        </section>
    );
};

export default PricingSimulator;
